import RouterClient from "../routerClient";
import Logger from "../logger";
import {
	InteropAddAppDefinitions,
	InteropRemoveAppDefinitions,
	InteropRegisterUIResolver,
	InteropSetRegistrationData,
	IntentResolverHandler,
	IntentTargetList,
	ResolverResolution,
	INTENT_RESOLVER_CHANNEL,
	SERVER_CHANNEL,
	AuthenticationToken,
} from "./types";

import { WindowDescriptor } from "../../services/window/types";

import { AppDefinition } from "../../services/Interop/types";

import { ResolveError } from "../../typedefs/FDC3";

export class InteropAdmin {
	#uuid = window.name;

	constructor() {}

	/**
	 * Provides the resolver with app definitions (used to build intent map plus other functionality)
	 * @param apps array of appD config definitions
	 */
	async addAppDefinitions(apps: Record<string, AppDefinition>): Promise<void> {
		const message: InteropAddAppDefinitions = {
			type: "addAppDefinitions",
			meta: {
				uuid: this.#uuid,
			},
			payload: {
				apps,
			},
		};
		await RouterClient.query(SERVER_CHANNEL, message);
	}

	/**
	 * Removes from the resolver a set of app definitions
	 * @param apps array of app names to remove
	 */
	async removeAppDefinitions(apps: string[]): Promise<void> {
		const message: InteropRemoveAppDefinitions = {
			type: "removeAppDefinitions",
			meta: {
				uuid: this.#uuid,
			},
			payload: {
				apps,
			},
		};
		await RouterClient.query(SERVER_CHANNEL, message);
	}

	/**
	 * Provides to InteropService addition window-service data needed for FDC3 registration.
	 *
	 * @param authenticationToken authentication token dynamically allocated by window service; required for authenticate the app
	 * @param windowDescriptor app's window descriptor, which can carry Interop window data

	 * @returns {Promise<void>}
	 * @memberof InteropAdmin
	 */
	async setInteropRegistrationData(windowDescriptor: WindowDescriptor): Promise<void> {
		const message: InteropSetRegistrationData = {
			type: "setInteropRegistrationData",
			meta: {
				uuid: this.#uuid,
			},
			payload: {
				windowDescriptor,
			},
		};
		await RouterClient.query(SERVER_CHANNEL, message);
	}

	async registerUIResolverListener(handler: IntentResolverHandler): Promise<void> {
		RouterClient.addResponder(INTENT_RESOLVER_CHANNEL, async (error, queryMessage) => {
			let resolverResolution: ResolverResolution | void;
			let errorResolution: ResolverResolution | void;
			if (!error) {
				const choices: IntentTargetList = queryMessage?.data;
				try {
					resolverResolution = await handler(choices);
				} catch (err) {
					Logger.log(`registerUIResolverListener IntentResolution rejected ${err}`);
					errorResolution = { error: ResolveError.ResolverUnavailable };
				}
				queryMessage?.sendQueryResponse(null, errorResolution || resolverResolution);
			} else {
				Promise.reject(
					`registerUIResolverListener failed. It can only be invoked once, system wide (router error: ${error})`
				);
			}
		});

		// let InteropService know that an intent resolver is available
		const message: InteropRegisterUIResolver = {
			type: "registerUIResolver",
			meta: {
				uuid: this.#uuid,
			},
		};
		await RouterClient.query(SERVER_CHANNEL, message);
	}
}

export default InteropAdmin;
